import React, { useState } from "react";
import Use_Alternative_Instrument_Form from "./use_Alternative_Instrument_Form/Use_Alternative_Instrument_Form";
import Use_Alternative_Instrument_table from "./use_Alternative_Instrument_table/Use_Alternative_Instrument_table";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Use_Alternative_Instrument({
  validitydetails,
  setCurrentPage,
  currentPage,
  openDeleteModal
}) {
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                          
  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.use_of_alternative_instrument.Add); //form


  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Use_Alternative_Instrument_Form
          validityTypeId={2}
          onProceed={() => setShowTable(true)}
        />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Use_Alternative_Instrument_table
         openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
           validityTypeId={2}
        /> }
      </div>
      {/* )} */}
    </>
  );
}

export default Use_Alternative_Instrument;
